// games/actionTypes.js

const CHANGE_PREVIOUS_SEASON_VALUE = '@@games/CHANGE_PREVIOUS_SEASON_VALUE';
const TEAMS_BY_DIVISION = '@@games/TEAMS_BY_DIVISION';
const TEAMS_BY_CONFERENCE = '@@games/TEAMS_BY_CONFERENCE';
const CHANGE_TEAM_SELECTION = '@@games/CHANGE_TEAM_SELECTION';
const CHANGE_DIVISION_SELECTION = '@@games/CHANGE_DIVISION_SELECTION';
const CHANGE_CONFERENCE_SELECTION = '@@games/CHANGE_CONFERENCE_SELECTION';
const CHANGE_ALL_SELECTION = '@@games/CHANGE_ALL_SELECTION';
const SELECT_INDIVIDUAL_TEAM = '@@games/SELECT_INDIVIDUAL_TEAM';
const HYDRATE_TEAM_FILTER = '@@games/HYDRATE_TEAM_FILTER';
const TOGGLE_CALENDAR_FILTER = '@@games/TOGGLE_CALENDAR_FILTER';
const TOGGLE_TEAM_FILTER = '@@games/TOGGLE_TEAM_FILTER';
const SET_GAME_LIST_PREPARING_TO_SCROLL = '@games/SET_GAME_LIST_PREPARING_TO_SCROLL';

export default {
    CHANGE_PREVIOUS_SEASON_VALUE,
    TEAMS_BY_DIVISION,
    TEAMS_BY_CONFERENCE,
    CHANGE_TEAM_SELECTION,
    CHANGE_DIVISION_SELECTION,
    CHANGE_CONFERENCE_SELECTION,
    CHANGE_ALL_SELECTION,
    SELECT_INDIVIDUAL_TEAM,
    HYDRATE_TEAM_FILTER,
    TOGGLE_CALENDAR_FILTER,
    TOGGLE_TEAM_FILTER,
    SET_GAME_LIST_PREPARING_TO_SCROLL
}